import { Api } from "./api"

const PATH = 'appointment' 
const ENDPOINTS = {
    Liste:'liste',
    Show:'show',
    Delete:'delete',
}

const getRdvs = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Liste}`, signal)
}

const getRdv = (id,signal) => {
    return Api.get(`${PATH}/${id}/${ENDPOINTS.Show}`, signal)
}

const deleteRdv = (id,signal) => {
    return Api.erase(`${PATH}/${id}/${ENDPOINTS.Delete}`, signal)
}

export const appointmentApi={
    getRdvs,
    getRdv,
    deleteRdv,
    
}